export default __webpack_public_path__ + "static/media/Westpac-logo.e76111f4.svg";